import { createStore } from 'redux';
import rootReducer from './reducers/rootReducer';

export default createStore(rootReducer);
